<div *ngIf="color=='yellow'" class="container bg-label-yellow">
    <p class="m-0">{{status.toUpperCase()}}</p>
</div>
<div *ngIf="color=='blue'" class="container bg-label-blue" fxLayout="column">
    <p class="m-0">{{status.toUpperCase()}}</p>
</div>
<div *ngIf="color=='green'" class="container bg-label-green" fxLayout="column">
    <p class="m-0">{{status.toUpperCase()}}</p>
</div>
<div *ngIf="color=='red'" class="container bg-label-red" fxLayout="column">
    <p class="m-0">{{status.toUpperCase()}}</p>
</div>